import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const CarBus: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 373.83c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m180.23 373.83c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m780 328.83h-75v-30h45v-195c0-24.81-20.19-45-45-45h-550.5l-59.52 119.04c-3.11 6.22-4.75 13.17-4.75 20.12v100.84h45v30h-75v-130.84c0-11.58 2.74-23.18 7.92-33.54l67.81-135.62h569.04c41.36 0 75 33.64 75 75z' />
    <path d='m220.23 298.83h399.77v30h-399.77z' />
    <path d='m600 207.66h-160s0-30 0-30h130c16.57 0 30 13.43 30 30z' />
    <path d='m390 327.66h-90v-210h90zm-60-30h30v-150h-30z' />
    <path d='m450 327.66h-90v-210h45c24.81 0 45 20.19 45 45zm-60-30h30v-135c0-8.27-6.73-15-15-15h-15z' />
    <path d='m85 177.66h235v30h-235z' />
    <path d='m480 735c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m120 735c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m525 660h60v30h-60z' />
    <path d='m600 690h-30v-120h-53.71l-47.04-82.33c-7.99-13.99-22.96-22.67-39.07-22.67h-198.75l-100 105h-86.43c-8.27 0-15 6.73-15 15v75h45v30h-75v-105c0-24.81 20.19-45 45-45h73.57l100-105h211.61c26.85 0 51.8 14.48 65.12 37.79l38.41 67.21h66.29z' />
    <path d='m160 660h280v30h-280z' />
    <path d='m480 570h-360s0-30 0-30h330c16.57 0 30 13.43 30 30z' />
    <path d='m330 465h30v105h-30z' />
  </IconBase>
));

CarBus.displayName = 'CarBus';

export default CarBus;
